var render = function render(){
  var _vm$lawyer, _vm$lawyer$ChoiYuna;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "sh": "태성 이혼가사변호사",
            "tabActive": "최유나 변호사 소개",
            "bg": "/images/sub/visual/sv-about.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "lawyer-view__head",
    attrs: {
      "tit": "최유나 변호사 소개",
      "titAdd": "법무법인 태성",
      "titClass": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function () {
        return [_c('v-img', {
          staticClass: "text-bg w-100",
          attrs: {
            "src": "/images/sub/taesung/lawyer/lawyer-bg.svg",
            "max-width": "1840",
            "aspect-ratio": 1840 / 266
          }
        })];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "lawyer-view__body secondary"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "7"
    }
  }, [_c('lawyer-choi-head')], 1), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "offset": "4",
      "offset-sm": "7",
      "offset-md": "0"
    }
  }, [_c('div', {
    staticClass: "lawyer-img-wrap"
  }, [_c('v-img', {
    staticClass: "lawyer-img w-100",
    attrs: {
      "data-aos": "fade-left",
      "src": "/images/lawyer/view/최유나.png",
      "max-width": "586",
      "aspect-ratio": 586 / 900
    }
  })], 1)])], 1)], 1), _c('page-section', {
    staticClass: "lawyer-view__foot page-section--last page-section--sm"
  }, _vm._l((_vm$lawyer = _vm.lawyer) === null || _vm$lawyer === void 0 ? void 0 : (_vm$lawyer$ChoiYuna = _vm$lawyer.ChoiYuna) === null || _vm$lawyer$ChoiYuna === void 0 ? void 0 : _vm$lawyer$ChoiYuna.info, function (info, index) {
    return _c('info-row', {
      key: index,
      attrs: {
        "title": info.title,
        "topLine": index == 0
      }
    }, [info.text ? [_vm._v(" " + _vm._s(info.text) + " ")] : _vm._e(), _vm._l(info.infoDetail, function (detail, index) {
      return _c('info-detail', {
        key: index,
        class: index !== 0 ? 'mt-10px mt-md-16px' : ''
      }, [typeof detail === 'string' ? _c('span', [_vm._v(_vm._s(detail))]) : detail.bold ? _c('strong', [_vm._v(_vm._s(detail.txt))]) : _vm._e()]);
    })], 2);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }